export default {
  name: 'BDescItem'
}
